import axios from 'axios';
import { apiUrl } from '../App';
import {Category, Product, ProductRequestDTO} from "../types/products/interfaces";

class ProductAndCategoryService {

    async createProduct(product: ProductRequestDTO): Promise<boolean> {
        try {
            const response = await axios.post(`${apiUrl}/product`, product);
            return response.status === 201;
        } catch (error) {
            console.error('Error while creating product:', error);
            return false;
        }
    }

    async deleteProduct(productId: string): Promise<boolean> {
        try {
            const response = await axios.delete(`${apiUrl}/product/${productId}`);
            return response.status === 204;
        } catch (error) {
            console.error('Error while deleting product:', error);
            return false;
        }
    }

    async updateProductMedia(
        productId: string,
        firstMedia: File | null, secondMedia: File | null, thirdMedia: File | null,
        fourthMedia: File | null, fifthMedia: File | null, sixthMedia: File | null,
        firstMediaKey: string | null, secondMediaKey: string | null, thirdMediaKey: string | null,
        fourthMediaKey: string | null, fifthMediaKey: string | null, sixthMediaKey: string | null
    ): Promise<void> {
        const formData = new FormData();

        if (firstMedia) formData.append('firstMedia', firstMedia);
        if (secondMedia) formData.append('secondMedia', secondMedia);
        if (thirdMedia) formData.append('thirdMedia', thirdMedia);
        if (fourthMedia) formData.append('fourthMedia', fourthMedia);
        if (fifthMedia) formData.append('fifthMedia', fifthMedia);
        if (sixthMedia) formData.append('sixthMedia', sixthMedia);

        formData.append('firstMediaKey', firstMediaKey ?? 'null');
        formData.append('secondMediaKey', secondMediaKey ?? 'null');
        formData.append('thirdMediaKey', thirdMediaKey ?? 'null');
        formData.append('fourthMediaKey', fourthMediaKey ?? 'null');
        formData.append('fifthMediaKey', fifthMediaKey ?? 'null');
        formData.append('sixthMediaKey', sixthMediaKey ?? 'null');

        try {
            await axios.post(`${apiUrl}/product/${productId}/update-media`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    async getAllProductsForAdmin(): Promise<Product[]> {
        try {
            const response = await axios.get(`${apiUrl}/product/admin`);
            return response.data;
        } catch (error) {
            console.error('Error while fetching products:', error);
            throw error;
        }
    }

    async updateProduct(updatedProduct: Product): Promise<boolean> {
        try {
            const response = await axios.post(`${apiUrl}/product/${encodeURIComponent(updatedProduct.id)}/update`, updatedProduct);
            return response.status === 201;
        } catch (error) {
            console.error('Error while updating product:', error);
            return false;
        }
    }

    async createCategory(categoryName: string): Promise<boolean> {
        try {
            const response = await axios.post(`${apiUrl}/product/category/create`, null, {
                params: { categoryName }
            });
            return response.status === 201;
        } catch (error) {
            console.error('Error while adding category: ', error);
            return false;
        }
    }

    async deleteCategory(categoryName: string): Promise<boolean> {
        try {
            const response = await axios.delete(`${apiUrl}/product/category`, {params: {categoryName}});
            return response.status === 204;
        } catch (error) {
            console.error('Error while deleting category: ', error);
            return false;
        }
    }

    async addParamInCategory(categoryName: string, parameterName: string): Promise<boolean> {
        try {
            const response = await axios.post(`${apiUrl}/product/category/param`, null, {
                params: { categoryName, parameterName }
            });
            return response.status === 201;
        } catch (error) {
            console.error('Error while adding category parameter: ', error);
            return false;
        }
    }

    async deleteParamInCategory(categoryName: string, parameterName: string): Promise<boolean> {
        try {
            const response = await axios.post(`${apiUrl}/product/category/delete-param`, null, {
                params: { categoryName, parameterName }
            });
            return response.status === 200;
        } catch (error) {
            console.error('Error while deleting category parameter: ', error);
            return false;
        }
    }

    async getAllCategories(): Promise<Category[]> {
        try {
            const response = await axios.get(`${apiUrl}/product/category`);
            return response.data;
        } catch (error) {
            console.error('Error while fetching categories: ', error);
            throw error;
        }
    }

    async addProductPosition(productId: string, size: string): Promise<boolean> {
        try {
            const response = await axios.put(`${apiUrl}/product/${productId}/${size}`);
            return response.status === 200;
        } catch (error) {
            console.error('Error while adding product position:', error);
            return false;
        }
    }

    async deleteProductPosition(productId: string, positionId: string): Promise<boolean> {
        try {
            const response = await axios.delete(`${apiUrl}/product/${productId}/${positionId}`);
            return response.status === 200;
        } catch (error) {
            console.error('Error while deleting product position:', error);
            return false;
        }
    }

}

const productAndCategoryService = new ProductAndCategoryService();
export default productAndCategoryService;
